import { SectionLabel } from "@/components/shared/SectionLabel";
import { RevealText } from "@/components/shared/RevealText";
import { ClientLogoMarquee } from "@/components/shared/ClientLogoMarquee";
import { CTAButton } from "@/components/shared/CTAButton";
import { CLIENT_LOGOS } from "@/data/siteData";

export const ClientsPreview = () => (
  <section className="py-24 px-6 bg-white">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-12">
        <SectionLabel>Our Clients</SectionLabel>
        <RevealText
          as="h2"
          text="Trusted by Schools"
          className="font-heading text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-tight"
        />
        <p className="mt-5 text-slate text-base leading-relaxed">
          We work with schools looking for dependable recruitment support and teaching talent.
        </p>
      </div>
      <ClientLogoMarquee logos={CLIENT_LOGOS} />
      <div className="mt-12">
        <CTAButton to="/clients" variant="secondary" testId="clients-preview-cta">
          View Our Clients
        </CTAButton>
      </div>
    </div>
  </section>
);
